import { Tooltip } from "antd";
import React from "react";
import { BACKUP_SUBSCRIPTION_TOOLTIP } from "../../constants/newCustomerBilling";

/**
 * Info (i) with backup subscription tooltip — Add Organization, etc.
 */
export default function BackupSubscriptionInfo({ className = "" }) {
  return (
    <Tooltip title={BACKUP_SUBSCRIPTION_TOOLTIP} placement="top">
      <button
        type="button"
        aria-label="Backup subscription information"
        className={`inline-flex h-6 w-6 items-center justify-center rounded-full border border-blue-200 bg-blue-50 text-blue-600 text-xs font-bold hover:bg-blue-100 ${className}`}
        onClick={(e) => e.stopPropagation()}
      >
        i
      </button>
    </Tooltip>
  );
}
